import React from "react";
import styled from "styled-components";
import theme from "../../theme";

export const Title = (props) => {
  const { title, description, progressNum } = props;
  const textColor = theme.colors.black;
  const progressActiveColor = theme.colors.orange;
  const progressNotActiveColor = theme.colors.grey;

  return (
    <Container color={textColor}>
      <TitleZone>
        <TitleStyle>{title}</TitleStyle>
        <Progress
          activeColor={progressActiveColor}
          notActiveColor={progressNotActiveColor}
        >
          <span>{progressNum}</span> / 4
        </Progress>
      </TitleZone>
      <Description>{description}</Description>
    </Container>
  );
};

const Container = styled.div`
  width: 20.5rem;
  height: auto;
  min-height: 4.375rem;
  display: flex;
  flex-direction: column;
  font-family: "SpoqaHanSansNeoRegular";
  font-weight: 700;
  font-style: normal;
  color: ${(props) => props.color};
`;

const TitleZone = styled.div`
  width: 100%;
  height: 1.625rem;
  margin-bottom: 0.5rem;
  display: flex;
  align-items: center;
`;

const TitleStyle = styled.div`
  margin-right: 0.5rem;
  line-height: 30px;
`;

const Progress = styled.div`
  color: ${(props) => props.notActiveColor};

  span {
    color: ${(props) => props.activeColor};
  }
`;

const Description = styled.div`
  width: 100%;
  height: 2.25rem;
  font-size: 24px;
  white-space: pre-wrap;
  line-height: 30px;
`;
